/**
 * The function will return the file name from the url
 * @param url
 */
export const getFileNameFromURL = (url: string) => {
  return url.split('/').pop()
}
